import { useState } from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Box } from "@mui/material";

const styles = {
	tabs: {
		minHeight: 0,
		pt: 2,

		"& .MuiTabs-indicator": {
			display: "none",
		},
		"& .MuiTabs-flexContainer": {
			columnGap: "10px",
		},
		"& .MuiTab-root": {
			textTransform: "capitalize",
			borderRadius: "6px 6px 0 0",
			bgcolor: "#FFF",
			color: "#333333",
			fontWeight: 500,
			minHeight: 0,
			fontSize: { md: 14, xs: 12 },
		},
		"& .MuiTab-root.Mui-selected": {
			bgcolor: "#0F4590",
			color: "#fff",
		},
	},
	whiteTab: {
		"& .MuiTabs-root": {
			borderBottom: 0,
			// bgcolor: "#FFF",
		},
		"& .MuiTabs-flexContainer": {
			borderBottom: "2px solid #fff",
		},
		"& .MuiTabs-root .MuiTab-root": {
			// bgcolor: "#FFF",
		},
	},
	whiteTabs: {
		"& .MuiTabs-root": {
			bgcolor: "#FFF !important",
		},
		borderBottom: "2px solid white",
		"& .MuiTabs-flexContainer": {
			gap: "10px",
		},
		"& .MuiTabs-indicator": {
			backgroundColor: "#0F4590",
		},
		"& button": {
			bgcolor: "#FFF",
			textTransform: "capitalize",
			borderTopLeftRadius: 6,
			borderTopRightRadius: 6,
			color: "#333333",
		},
	},
};

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ py: 2 }}>{children}</Box>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

export default function CustomTabs({ tabList, bgcolor, defaultTabIndex = 0 }) {
	const [value, setValue] = useState(
		defaultTabIndex >= 0 ? defaultTabIndex : 0
	);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%" }}>
			<Box
				sx={{
					...(bgcolor && styles.whiteTab),
					borderBottom: 1,
					borderColor: "#F2F2F2",
				}}
			>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example"
					sx={{ ...(bgcolor && styles.whiteTabs), ...styles.tabs }}
				>
					{tabList.map((tab, index) => (
						<Tab
							key={`tab${tab.label}${index}`}
							label={tab.label}
							{...a11yProps(index)}
						/>
					))}
				</Tabs>
			</Box>

			{tabList.map((tab, index) => (
				<TabPanel
					key={`tabpanel${tab.label}${index}`}
					value={value}
					index={index}
				>
					{tab.component}
				</TabPanel>
			))}
		</Box>
	);
}
